<template>
  <div class="dropdown dropdown-end text-white" :class="{ 'dropdown-open': dropdownVisible }">
    <label @click="dropdownVisible = !dropdownVisible" class="btn btn-ghost rounded-btn">
      <img :src="`https://flagsapi.com/${languageToFlagCode[locale]}/flat/24.png`" />
      {{ locale }}
    </label>
    <ul class="menu dropdown-content z-50 p-2 shadow bg-base-100 rounded-box w-24 mt-4">
      <li v-for="localization in localizations" :key="localization">
        <a @click="onSelect(localization)">
          <img :src="`https://flagsapi.com/${languageToFlagCode[localization]}/flat/24.png`" />
          {{ localization.toUpperCase() }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { useI18n } from 'vue-i18n'

const { locale } = useI18n({ useScope: 'global' })

const localizations = ['en', 'hr', 'nl', 'pt', 'fi', 'es']

const dropdownVisible = ref(false)

const languageToFlagCode: { [key: string]: string } = {
  en: 'GB',
  hr: 'HR',
  nl: 'BE',
  pt: 'PT',
  fi: 'FI',
  es: 'ES'
}

onMounted(() => {
  const lastLocalization = localStorage.getItem('localization')

  if (lastLocalization && localizations.includes(lastLocalization)) {
    locale.value = lastLocalization
  }
})

const onSelect = (language: string) => {
  locale.value = language
  dropdownVisible.value = false
  localStorage.setItem('localization', language)
}
</script>
